import React, { useState } from 'react';
import styled from '@emotion/styled';
import AgencyEmptyAvatarIcon from 'assets/svg/agency-empty-avatar.svg';

const Root = styled.div`
  ${({ theme }) => `
    width: 88px;
    height: 88px;
    border: solid 2px ${theme.colors.neutrals.white};
    border-radius: ${theme.borderRadius.tiny};
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.colors.neutrals.grey10};
    > svg {
      width: 48px;
      height: 48px;
    }
    > img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  `}
`;

interface AgencyAvatarProps {
  imageUrl?: string;
}

export const AgencyAvatar: React.FC<AgencyAvatarProps> = props => {
  const { imageUrl } = props;
  const [ imageLoadFailed, setImageLoadFailed ] = useState(false);
  const isImageVisible = imageUrl && !imageLoadFailed;

  const handleFailedLoadImage = () => setImageLoadFailed(true);

  return (
    <Root>
      {isImageVisible
        ? <img src={imageUrl} onError={handleFailedLoadImage} />
        : <AgencyEmptyAvatarIcon />
      }
    </Root>
  );
};
